import React, { useState, useEffect } from "react";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { auth } from "../firebase"; // ✅ Use initialized Firebase app

const AuthModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  const handleSignup = async () => {
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      setMessage("Signed up successfully!");
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setMessage("Logged in!");
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setMessage("Logged out.");
  };

  if (!isOpen) return null;

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h2 style={styles.heading}>Member Login / Signup</h2>
        {isLoggedIn ? (
          <>
            <p>You're logged in</p>
            <button style={styles.logoutButton} onClick={handleLogout}>
              Log Out
            </button>
          </>
        ) : (
          <>
            <input
              type="email"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
            />
            <input
              type="password"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
            />
            <div style={styles.buttonRow}>
              <button onClick={handleLogin} style={styles.button}>
                Log In
              </button>
              <button onClick={handleSignup} style={styles.buttonAlt}>
                Sign Up
              </button>
            </div>
          </>
        )}
        <p style={styles.message}>{message}</p>
        <button onClick={onClose} style={styles.closeButton}>
          Close
        </button>
      </div>
    </div>
  );
};

const styles = {
  backdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modal: {
    background: "#ffffff",
    padding: "2.5rem",
    borderRadius: "16px",
    maxWidth: "400px",
    width: "90%",
    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
    fontFamily: "'Poppins', sans-serif",
    textAlign: "center",
  },
  heading: {
    marginBottom: "1.5rem",
    fontWeight: "600",
    fontSize: "1.5rem",
    color: "#222",
  },
  input: {
    width: "100%",
    padding: "0.8rem",
    marginBottom: "1rem",
    fontSize: "1rem",
    borderRadius: "10px",
    border: "1px solid #ccc",
    outline: "none",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    marginBottom: "1rem",
  },
  button: {
    flex: 1,
    padding: "0.75rem",
    fontSize: "1rem",
    backgroundColor: "#222",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
  },
  buttonAlt: {
    flex: 1,
    padding: "0.75rem",
    fontSize: "1rem",
    backgroundColor: "#f1f1f1",
    color: "#222",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
  },
  logoutButton: {
    marginTop: "1rem",
    backgroundColor: "#444",
    color: "#fff",
    border: "none",
    padding: "0.7rem 1.5rem",
    borderRadius: "10px",
    cursor: "pointer",
  },
  closeButton: {
    marginTop: "1rem",
    backgroundColor: "#e0e0e0",
    padding: "0.6rem 1.2rem",
    borderRadius: "8px",
    border: "none",
    fontSize: "0.9rem",
    cursor: "pointer",
  },
  message: {
    color: "#00aa55",
    fontSize: "0.9rem",
    marginTop: "0.5rem",
    minHeight: "1rem",
  },
};

export default AuthModal;
